
import { constants } from "../constant/constant";
import { httpservice } from '../services';
import { PLATFORM } from '../constant/actionTypes';
import { dateFormat } from "../helper/StringUtils";

export default (object) => dispatch => {
    let query;
    if(object){
        query = `${constants.API.SOFTWARE_MODULE_PLATFORM}/${object.id}`
    } else {
        query = `${constants.API.PLATFORM}`;
    }
    dispatch({
        payload: [],
        type: PLATFORM.DATA.INITIATE
    });
    return httpservice()
        .get(query)
        .then(response => {
            const { rows = [], count = 0} = response.data.response;
            const responseData = rows.map(data => {
                data.platform = data.platform.charAt(0).toUpperCase() + data.platform.slice(1);
                data.created_at = dateFormat(data.createdAt);
                data.createdBy = data.creator ? data.creator.firstName + ' ' + data.creator.lastName : 'admin';
                return data;
            });
            dispatch({
                payload: { data: responseData, count: count },
                type: PLATFORM.DATA.SUCCESS
            });
            return responseData;
        })
        .catch(function (error) {
            dispatch({
                payload: error,
                type: PLATFORM.DATA.ERROR
            });
        })
};


